/*
 * For more information about the V1 Rest API see:
 * https://www.revenuecat.com/docs/api-v1
 */

import type { Maybe } from '@/helpers/types';
import type { GetOrCreateCustomerResponse } from './types';

import axios from 'axios';

const revenueCatAPI = axios.create({ baseURL: `${JW_CONFIG.REVENUE_CAT_API_URL}` });

revenueCatAPI.interceptors.request.use(
	async config => {
		config.headers = {
			Authorization: `Bearer ${JW_CONFIG.REVENUE_CAT_PUBLIC_KEY}`,
		};
		return config;
	},
	error => Promise.reject(error)
);

/** Gets the latest Customer Info for the customer with the given App User ID, or creates a new customer if it doesn't exist. */
export async function getOrCreateSubscriber(jwId: Maybe<string>): Promise<GetOrCreateCustomerResponse | null> {
	try {
		if (jwId == null) return null;

		const response = await revenueCatAPI.get<GetOrCreateCustomerResponse>(`/subscribers/${jwId}`);
		return response.data;
	} catch {
		return null;
	}
}
